// extracted by mini-css-extract-plugin
export default {"statsContainer":"StatsPanel_statsContainer__GS3rO","statsItem":"StatsPanel_statsItem__f3KC9"};